let CURRENT_PAGE = 1
let TOTAL_PAGES = null
let FILTER_BY = 'market'
let FILTER_ID = null
let REQUEST = null

export default {
  init () {
    let that = this

    that.initFilter()
    that.getData(1)
    that.initLoadMoreHandler()
    that.setArrowPosition();
    that.initSelectFilter();

    window.addEventListener('resize', function () {
      that.setArrowPosition();
    });
  },

  initFilter () {
    let that = this
    $('.filter-by').on('click', (el) => {
      let filterBy = $(el.target).data('filter')
      let activeFilter = $('.filter-by.active').data('filter')
      if (filterBy === activeFilter) return false;
      $('.filter-by.active').removeClass('active')
      $('.filter-by[data-filter="'+ filterBy +'"]').addClass('active')
      if (filterBy === 'market') {
        // resets the filter ID everytime a user clicks on the filterby category
        // so it can make the right call when switching from filterby category.
        FILTER_ID = 0;
        FILTER_BY = 'market'
        $('.cat-filter-nav[data-filter="market"]').addClass('inline-flex').removeClass('hidden')
        $('.cat-filter-nav[data-filter="service"]').addClass('hidden')

        $('.filter-select[data-filter="market"]').addClass('block').removeClass('hidden')
        $('.filter-select[data-filter="service"]').addClass('hidden').removeClass('block')
      } else if (filterBy === 'service') {
        // resets the filter ID everytime a user clicks on the filterby category
        // so it can make the right call when switching from filterby category.
        FILTER_ID = 0;
        FILTER_BY = 'service'
        $('.cat-filter-nav[data-filter="market"]').addClass('hidden').removeClass('inline-flex')
        $('.cat-filter-nav[data-filter="service"]').removeClass('hidden')

        $('.filter-select[data-filter="market"]').addClass('hidden').removeClass('block')
        $('.filter-select[data-filter="service"]').addClass('block').removeClass('hidden')
      } else {
        FILTER_ID = 0;
        FILTER_BY = 'all'
        $('.cat-filter-nav[data-filter="market"]').addClass('hidden')
        $('.cat-filter-nav[data-filter="service"]').addClass('hidden')

        $('.filter-select[data-filter="market"]').addClass('hidden')
        $('.filter-select[data-filter="service"]').addClass('hidden')
      }

      if (filterBy !== 'all') {
        $('.cat-filter-nav[data-filter="'+filterBy+'"] a.active').removeClass('active')
        $('.cat-filter-nav[data-filter="'+filterBy+'"] a[data-id="0"]').addClass('active')
        $('.cat-filter-nav[data-filter="'+filterBy+'"] a').first().addClass('active')
        $('.filter-select[data-filter="' + filterBy + '"] select option[value="0"]').attr('selected', 'selected')
      }

      CURRENT_PAGE = 1
      TOTAL_PAGES = null
      that.setArrowPosition()
      that.getData(1)
    });

    $('.cat-filter-nav[data-filter="market"] a').on('click', (el) => that.handleFilter(el, "market"));
    $('.cat-filter-nav[data-filter="service"] a').on('click', (el) => that.handleFilter(el, "service"));
  },

  initLoadMoreHandler () {
    let that = this
    $('#project-loadMore button').on('click', (event) => {
      $(event.currentTarget).addClass('hover:bg-mango-tango bg-opacity-50 hover:bg-opacity-50 cursor-not-allowed')
      $('#project-loadMore button').removeClass('hover:bg-blue-prussian')
      $(event.currentTarget).prop('disabled', true)
      $(event.currentTarget).html(`
        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg> Load More
      `)
      that.getData(++CURRENT_PAGE)
    });
  },

  setArrowPosition () {
    let elWidth2 = $('.filter-sm .filter-by.active').width();
    let elPosition2 = $('.filter-sm .filter-by.active').position().left
    let arrowWidth2 = $('.filter-arrow.arrow-2').width()
    let position2 = ((elWidth2 - arrowWidth2) / 2) + elPosition2
    $('.filter-arrow.arrow-2').css({ 'transform': 'translateX(' + position2 + 'px)' })
  },

  initSelectFilter () {
    $('.filter-select[data-filter="market"] select').on('change', function () {
      let id = $(this).val();
      $('.cat-filter-nav[data-filter="market"] a[data-id="'+id+'"]').trigger('click')
      $(this).trigger('blur');
    })

    $('.filter-select[data-filter="service"] select').on('change', function () {
      let id = $(this).val();
      $('.cat-filter-nav[data-filter="service"] a[data-id="' + id + '"]').trigger('click')
      $(this).trigger('blur');
    })
  },

  getData (page_num) {
    let that = this
    let market_id = 0
    let service_id = 0

    if (FILTER_BY === 'market' && FILTER_ID !== null) {
      market_id = FILTER_ID
    }

    if (FILTER_BY === 'service' && FILTER_ID !== null) {
      service_id = FILTER_ID
    }

    REQUEST = $.ajax({
      type: 'GET',
      url: '/wp-json/api/v1/projects',
      data: {
        per_page: 21,
        page: page_num,
        market_id: market_id,
        service_id: service_id,
        filter_by: FILTER_BY,
      },
      beforeSend: function () {
        if (REQUEST) {
          REQUEST.abort();
        }

        if ($('.project-item').length) {
          $('.project-item').off('click')
        }
        if (TOTAL_PAGES === null) {
          // reset the list
          $('#project-list').html('')
          // show loading spinner
          $('#project-loader').addClass('flex').removeClass('hidden')
          // hide empty data info
          $('#project-empty').addClass('hidden').removeClass('flex')
          // hide load more button
          $('#project-loadMore').addClass('hidden').removeClass('flex')
        }
      },
      success: function (data) {
        CURRENT_PAGE = parseInt(data.current_page);
        TOTAL_PAGES = parseInt(data.total_pages);

        if ((TOTAL_PAGES > 1) && (TOTAL_PAGES > CURRENT_PAGE)) {
          $('#project-loadMore').removeClass('hidden').addClass('flex');
        } else {
          $('#project-loadMore').addClass('hidden').removeClass('flex');
        }

        if (data.data.length === 0) {
          $('#project-empty').removeClass('hidden').addClass('flex');
        } else {
          $('#project-empty').addClass('hidden').removeClass('flex');
          that.drawHtml(data.data);
          window.initLazyLoad.update();

          $('.project-item').on('click', function () {
            if (!$(this).hasClass('hover-active')) {
              $('.project-item.hover-active').removeClass('hover-active')
              $(this).addClass('hover-active');
            } else {
              $(this).removeClass('hover-active');
            }
          })
        }
      },
      complete: function () {
        REQUEST = null
        $('#project-loadMore button').html('Load More')
        $('#project-loadMore button').removeClass('hover:bg-mango-tango bg-opacity-50 hover:bg-opacity-50 cursor-not-allowed').addClass('hover:bg-blue-prussian')
        $('#project-loadMore button').prop('disabled', false)
        $('#project-loader').addClass('hidden')
        $('#project-loader').removeClass('flex')
      },
    })
  },

  handleFilter (el, type) {
    $('.cat-filter-nav[data-filter="' + type + '"] a.active').removeClass('active')
    $(el.target).addClass('active')
    CURRENT_PAGE = 1
    TOTAL_PAGES = null
    let id = $(el.target).data('id')
    $('.filter-select[data-filter="' + type + '"] select option[value="'+id+'"]').attr('selected', 'selected')
    FILTER_ID = id == 0 ? null : id
    this.getData(1)
    this.setArrowPosition()
  },

  drawHtml (data) {
    const scrollTop = $(window).scrollTop();

    $.each(data, function (idx, item) {
      let thumbnail = item.thumbnail !== null ? item.thumbnail : '/app/themes/aptim/public/images/no-image.png';

      $('#project-list').append(`
        <div id="project-${item.id}" class="project-item relative col-span-1 rounded-md bg-gray-50">
          `/*<div class="info-service absolute text-sm text-white bg-transparent left-5 md:left-8 top-6 invisible opacity-0 transition z-2">
            ${item.services.length ? item.services[0].title : ''}
          </div>*/
          +`<div class="image-keep-ratio by-66-66 rounded-md">
            <img data-src="${thumbnail}" alt="${item.title}" class="lazy w-full h-auto object-cover rounded-md" />
          </div>
          <div class="info-title item absolute left-0 bottom-0 flex justify-between items-center space-x-8 w-full bg-blue-prussian bg-opacity-90 text-white rounded-md px-5 md:px-8 h-20 transition-[height]">
            <div class="flex-shrink">
              <a href="${item.permalink}" class="title font-medium uppercase" title="${item.title}">
                ${item.title}
              </a>
            </div>

            <div class="circled-arrow flex items-center flex-shrink-0 h-full">
              <span class="flex justify-center items-center w-9 h-9 rounded-full text-white border border-white transform transition">
                <svg xmlns="http://www.w3.org/2000/svg" width="8.18" height="6.524" viewBox="0 0 8.18 6.524" class="transition">
                  <path d="M391.258,300.5l5.358,3.678-5.358,3.678" transform="translate(308.268 -390.975) rotate(90)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1" />
                </svg>
              </span>
            </div>
          </div>

          <div class="info-year-completed absolute text-sm text-white bg-transparent left-6 md:left-8 bottom-6 invisible opacity-0 transition z-2">
            ${item.year_completed}
          </div>
        </div>
      `)

      $(window).scrollTop(scrollTop);
    })
  },

  setProperWidths () {
    $('.js-child-width > a').each(function() {
      $(this).parent().css("max-width", "100%");
    });

    setTimeout(() => {
      const widths = [];
      $('.js-child-width > a').each(function() {
        const id = $(this).data('id');
        widths.push({ id, width: $(this).width() + "px"});
      });

      $('.js-child-width > a').each(function() {
        const id = $(this).data('id');
        $(this).parent().css("max-width", widths.find((w) => w.id == id).width);
      });
    }, 100);
  },
}
